export default __webpack_public_path__ + "ARUP_VDA_Tool_Acceptable_Use_and_Privacy_Policy.pdf";